import { render, staticRenderFns } from "./BannerLayout.vue?vue&type=template&id=206f4e69&scoped=true"
import script from "./BannerLayout.vue?vue&type=script&lang=js"
export * from "./BannerLayout.vue?vue&type=script&lang=js"
import style0 from "./BannerLayout.vue?vue&type=style&index=0&id=206f4e69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206f4e69",
  null
  
)

export default component.exports